// Core
import React, { useState, useEffect, Suspense } from 'react';
import {
  Card, Row, Col, Menu, Skeleton, PageHeader, Form, Radio, notification
} from 'antd';
import { Switch, Redirect, Route, useParams, useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import { UserOutlined, DollarOutlined, MedicineBoxOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';

// App
import { RecordViewWrapper } from './Style';
import { Main, TableWrapper } from '../../styled';
import { Cards } from '../../../components/cards/frame/cards-frame';
import CorteDiaByCajeroView from './CorteDiaByCajero';
import CorteDiaByFormaPagoView from './CorteDiaByFormaPago';

const CorteCajaMenu = () => {
  const { url } = useRouteMatch();
  const location = useLocation();
  const history = useHistory();

  const navigateTo = url => {
    history.replace(url)
  }

  const menuReportes = (<div className='noprint'><Radio.Group onChange={e => navigateTo(e.target.value)}>
    <Radio.Button value={url + '/cajero'}><UserOutlined /> Por cajero</Radio.Button>
    <Radio.Button value={url + '/forma-pago'}><DollarOutlined /> Por forma de pago</Radio.Button>
    <Radio.Button value={url + '/dentista'}><UserOutlined /> Por dentista</Radio.Button>
    <Radio.Button value={url + '/servicio'}><MedicineBoxOutlined /> Por servicio</Radio.Button>
  </Radio.Group></div>
  )

  return (
    <RecordViewWrapper>
      <PageHeader
        subTitle="Te permite consultar el corte de caja del día de la sucursal"
        ghost
        title="CORTE DE CAJA"
        footer={menuReportes}
      />
      <Main>
        <Row gutter={24}>
          <Col className="w-100" md={24}>
            <Cards headless>
              <Switch>
                <Suspense
                  fallback={
                    <Cards headless>
                      <Skeleton paragraph={{ rows: 10 }} active />
                    </Cards>
                  }
                >
                  <Route exact path={`${url}/cajero`} component={CorteDiaByCajeroView} />
                  <Route exact path={`${url}/forma-pago`} component={CorteDiaByFormaPagoView} />
                  <Route exact path={`${url}/dentista`} component={CorteDiaByCajeroView} />
                  <Route exact path={`${url}/servicio`} component={CorteDiaByCajeroView} />
                  <Redirect to={`${url}/cajero`} />
                </Suspense>
              </Switch>

            </Cards>
          </Col>
        </Row>
      </Main>
    </RecordViewWrapper>
  );
};

export default CorteCajaMenu;
